import { render, staticRenderFns } from "./CrewForm.vue?vue&type=template&id=4965e58f&"
import script from "./CrewForm.vue?vue&type=script&lang=js&"
export * from "./CrewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports